export const iconProps = {
  size: {
    type: [Number, String],
    required: false,
    default: 50,
  },
  fill: {
    type: String,
    required: false,
    default: 'currentColor',
  },
}
